import { ButtonHTMLAttributes } from "react";
import styled from "styled-components";
import { H4, Mini } from "../../styles/stringStyles";
import { useStyles } from "../../styles/theme";
import { hexWithOpacity } from "../../utils/helpers";
import { ImageComponent } from "../ImageComponent";
import { CustomButton } from "./CustomButton";
import { IconButton } from "./IconButton";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
  loading?: boolean;
  title?: string;
  subtitle?: string;
  imageUrl?: string;
};

export const CardButton = (props: Props) => {
  const theme = useStyles();

  return (
    <StyledCustomButton
      className={props.className}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.imageUrl && (
        <Image src={props.imageUrl} alt={props.title} imageFit="contain" />
      )}
      <HeaderContainer>
        {props.title && (
          <CardTitle className="card-title">{props.title}</CardTitle>
        )}
        {props.subtitle && (
          <Subtitle className="card-subtitle">{props.subtitle}</Subtitle>
        )}
      </HeaderContainer>
      <IconButton
        iconName="ArrowRight"
        size={24}
        primaryColor={theme.colors.white}
        bgCircle={{
          color: theme.colors.dark,
          size: 32,
          borderRadius: 10,
        }}
      />
    </StyledCustomButton>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;
`;

const Subtitle = styled(Mini)`
  color: ${({ theme }) => hexWithOpacity(theme.colors.dark, 0.5)};
  width: 100%;
  text-align: left;
`;

const CardTitle = styled(H4)`
  text-align: left;
`;

const StyledCustomButton = styled(CustomButton)`
  position: relative;
  border-radius: 15px;
  width: 100%;
  min-width: 280px;
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
`;

const Image = styled(ImageComponent)`
  min-width: 80px;
  max-width: 80px;
  width: 100%;
  height: 60px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.light};
`;
